export default __webpack_public_path__ + "static/media/0K9A9189.f05c5101.JPG";